/**
 * This file specifies the state of the application in response to App actions
 */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  influencers: {
    data: [],
    error: null,
    loading: false,
    count: 0,
  },
  team: {
    data: [],
    error: null,
    loading: false,
    count: 0,
  },
};

const slice = createSlice({
  name: 'social_media',
  initialState,
  reducers: {
    getInfluencers: (state) => ({
      ...state,
      influencers: {
        ...state.influencers,
        error: null,
        loading: true,
      },
    }),
    getInfluencersError: (state, action) => ({
      ...state,
      influencers: {
        ...state.influencers,
        error: action.payload.error,
        loading: false,
      },
    }),
    getInfluencersSuccess: (state, action) => ({
      ...state,
      influencers: {
        ...state.influencers,
        data: action.payload.rows,
        count: action.payload.count,
        loading: false,
        error: null,
      },
    }),
    getTeam: (state) => ({
      ...state,
      team: {
        ...state.team,
        error: null,
        loading: true,
      },
    }),
    getTeamError: (state, action) => ({
      ...state,
      team: {
        ...state.team,
        error: action.payload.error,
        loading: false,
      },
    }),
    getTeamSuccess: (state, action) => ({
      ...state,
      team: {
        ...state.team,
        data: action.payload.rows,
        count: action.payload.count,
        loading: false,
        error: null,
      },
    }),
  },
});

export const { reducer, actions } = slice;

export default reducer;
